'use client';

import { useEffect } from 'react';
import { signIn } from 'next-auth/react';
import Link from 'next/link';
import styles from '../../styles/Home.module.css';

interface LoginClientProps {
  callbackUrl?: string;
  error?: string;
}

export default function LoginClient({ callbackUrl = '/', error }: LoginClientProps) {
  // Auto-redirect to Zitadel if no error
  useEffect(() => {
    if (!error) {
      signIn('zitadel', { callbackUrl });
    }
  }, [error, callbackUrl]);

  // Show loading state while redirecting
  if (!error) {
    return (
      <div className={styles.main} data-lk-theme="default" style={{ justifyContent: 'center', alignItems: 'center' }}>
        <div className={styles.card} style={{ maxWidth: '380px', textAlign: 'center' }}>
          <div className={styles.spinner} style={{ margin: '0 auto 1rem' }} aria-hidden="true" />
          <p style={{ margin: 0, color: 'rgba(255,255,255,0.7)' }}>Redirigiendo a autenticación…</p>
        </div>
      </div>
    );
  }

  // Show error UI
  return (
    <div className={styles.main} data-lk-theme="default" style={{ justifyContent: 'center', alignItems: 'center' }}>
      <div className={styles.card} style={{ maxWidth: '380px' }}>
        <h2 className={styles.cardTitle}>Error de Autenticación</h2>

        <p className={styles.errorText} role="alert" style={{ marginBottom: '1.5rem' }}>
          {error === 'AccessDenied'
            ? 'No tienes permisos para acceder'
            : error === 'Configuration'
              ? 'Error de configuración. Contacta al administrador.'
              : 'Error de autenticación. Intenta nuevamente.'}
        </p>

        <button
          onClick={() => signIn('zitadel', { callbackUrl })}
          className={styles.createButton}
          style={{ marginBottom: '0.75rem' }}
        >
          Reintentar
        </button>

        <Link href="/" className={styles.secondaryButton}>
          Volver al Inicio
        </Link>
      </div>
    </div>
  );
}
